/* eslint-disable import/first */
import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import * as config from "config/config";

class DeleteLivreur extends Component {
	constructor() {
		super();
	}
	componentDidMount() {
		config
			.apiFetch(config.Api_Url + "/delete/livreurs", {
				method: "POST",
				body: JSON.stringify({
					livreur_id: this.props.match.params.id,
				}),
				headers: { "Content-Type": "application/json" },
			})
			.then((response) => response.json())
			.then((data) => {
				this.props.history.goBack();
			});
	}
	render() {
		return null;
	}
}

export default withRouter(DeleteLivreur);
